const pageHeader = document.querySelector('#pageheader');
const headerAccountLink = document.querySelector('.header-account-link.logged-in');
let accountMenuOpen = false;

headerAccountLink?.addEventListener('click', (event) => {
  const accountMenu = document.querySelector('.header-account__menu--wrapper');
  if(event.target === accountMenu || accountMenu.contains(event.target)) {
    return;
  }
  accountMenuOpen = true;
  accountMenu.classList.toggle('header-account__menu--wrapper-visible');
});

pageHeader.addEventListener('mouseenter', function() {
  this.closest('.section-header').classList.add('section-header--nav-hover');
});

pageHeader.addEventListener('mouseleave', function() {
  if(!accountMenuOpen) {
    this.closest('.section-header').classList.remove('section-header--nav-hover');
  }
});

document.addEventListener('click', (event) => {
  const headerAccountLink = document.querySelector('.header-account-link.logged-in');
  if(!headerAccountLink.contains(event.target)) {
    const accountMenu = document.querySelector('.header-account__menu--wrapper');
    accountMenu.classList.remove('header-account__menu--wrapper-visible');

    if(accountMenuOpen) {
      headerAccountLink.closest('.section-header').classList.remove('section-header--nav-hover');
      accountMenuOpen = false;
    }
    
  }
});